__turbopack_context__.v({
  "body": "AccessControlFaq-module__SaDxvW__body",
  "columns": "AccessControlFaq-module__SaDxvW__columns",
  "item": "AccessControlFaq-module__SaDxvW__item",
});
